module.exports = __webpack_public_path__ + "01c6bdd1a8eff78ebf3bfac36529dbdf.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=410!./images/head/foerdermitglied.jpg
// module id = 486
// module chunks = 0